import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SharingComponent } from './sharing.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: ':url',
    component: SharingComponent,
    data: { title: 'Compartir en Conectimed' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class SharingRoutingModule {}
